const hardSkillsIcons = [
  {
    icon: 'akar-icons:nextjs-fill',
    className: 'about-icon',
    title: 'NextJS' 
  },
  {
    icon: 'akar-icons:react-fill',
    className: 'about-icon',
    title: 'ReactJS' 
  },
  {
    icon: 'cib:javascript',
    className: 'about-icon',
    title: 'JavaScript' 
  },
  {
    icon: 'fontisto:css3',
    className: 'about-icon',
    title: 'CSS' 
  },
  {
    icon: 'ri:nextjs-fill',
    className: 'about-icon',
    title: 'NextJS' 
  },
  {
    icon: 'solar:figma-bold',
    className: 'about-icon',
    title: 'Figma' 
  },
  {
    icon: 'cib:typescript',
    className: 'about-icon',
    title: 'Typescript' 
  },
  {
    icon: 'tabler:brand-react-native',
    className: 'about-icon',
    title: 'React Native' 
  },
  {
    icon: 'simple-icons:mui',
    className: 'about-icon',
    title: 'Material UI' 
  },
  {
    icon: 'akar-icons:bootstrap-fill',
    className: 'about-icon',
    title: 'Bootstrap' 
  },
  {
    icon: 'icomoon-free:html-five',
    className: 'about-icon',
    title: 'HTML' 
  },
  {
    icon: 'bi:git',
    className: 'about-icon',
    title: 'Git' 
  },
  {
    icon: 'fontisto:github',
    className: 'about-icon',
    title: 'GitHub' 
  },
  {
    icon: 'fontisto:mysql',
    className: 'about-icon',
    title: 'MySQL' 
  },
  {
    icon: 'file-icons:docker',
    className: 'about-icon',
    title: 'Docker' 
  },
  {
    icon: 'bxl:nodejs',
    className: 'about-icon',
    title: 'NodeJS' 
  },
];

export default hardSkillsIcons;